import { api } from ".";

export interface AssetSummary {
    ActiveCustomers: number;
    ActiveApplications: number;
    ActiveUsers: number;
    ActiveIntegrations: number;
}

export interface AppRegSecretSummary {
    ExpiringNextWeek: number;
    ExpiringNextMonth: number;
    AlreadyExpired: number;
}

const appUrlV1 = "/v1/Dashboard";

export const getAssets = async () => {
  const response = await api.get<AssetSummary>(`${appUrlV1}/assets`);
  return response?.data;
};

export const getSecrets = async () => {
  const response = await api.get<AppRegSecretSummary>(`${appUrlV1}/secrets`);
  return response?.data;
}; 